export function handleSearch() {
  handlePressEnter()
}

function handlePressEnter() {
  const searchInput = $('.primary-mobile-menu .search-input')
  const searchInputHeader = $('.search-input-header')
  searchInput.keypress(function(e) {
    const keyword = $(this).val().trim()
    if (e.key === 'Enter' && keyword !== '') {
      window.location = '/?s=' + keyword
    }
  })
  searchInputHeader.keypress(function(e) {
    const keyword = $(this).val().trim()
    if (e.key === 'Enter' && keyword !== '') {
      window.location = '/?s=' + keyword
    }
  })
  $('.icon-search').click(function() {
    const keyword = $(this).closest('.search-wrap').find('input').val().trim()
    window.location = '/?s=' + keyword
  })
  $('.icon-search-header').click(function() {
    const keyword = $(this).closest('.search-wrap').find('input').val().trim()
    window.location = '/?s=' + keyword
  })
}



// WEBPACK FOOTER //
// ./scripts/func/search.js